/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    // Memaksa root elemen jadi full height agar background mengisi layar
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-lg-row flex-column-fluid'
      // Wajib minHeight 100vh agar kontainer kanan tingginya full layar
      style={{minHeight: '100vh'}}
    >
      {/* ================= BAGIAN KIRI: FORM ================= */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
        </div>
        {/* Footer Link Kosong */}
        <div className='d-flex flex-center flex-wrap px-5'></div>
      </div>

      {/* ================= BAGIAN KANAN: GAMBAR RATA KANAN & UTUH ================= */}
      <div
        // class 'bg-body' agar warna background area kosong menyesuaikan tema (gelap/terang)
        className='d-flex flex-lg-row-fluid w-lg-50 order-1 order-lg-2 bg-body'
        style={{
          // 1. Masukkan path gambar yang benar
          backgroundImage: `url(${toAbsoluteUrl('/media/misc/carmain.svg')})`,

          // 2. Jangan ulangi gambar
          backgroundRepeat: 'no-repeat',

          // 3. KUNCI AGAR TIDAK TERPOTONG (Tampil Utuh)
          backgroundSize: 'contain',

          // 4. KUNCI AGAR RATA KANAN (dan tengah vertikal)
          backgroundPosition: 'right center',
        }}
      >
        {/* Isinya kosongkan saja agar gambar background terlihat jelas */}
      </div>
    </div>
  )
}

export {AuthLayout}
